<template>
  <div class="px-5 mx-auto md:w-96 py-2">
    <!-- Add Item Button -->
    <Button class="flex w-full h-10 bg-blue-400 rounded-xl text-center">
      <router-link class="w-full" :to="menuitempath">افزودن آیتم</router-link>
    </Button>

    <!-- Search Box and Button -->
    <div class="flex gap-2 mb-4 mt-2">
      <input 
        v-model="searchTerm" 
        type="text" 
        placeholder="جستجو کالا" 
        class="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-300"
      />
      <Button @click="searchItems" class="bg-blue-500 rounded-lg px-4 text-white">جستجو</Button>
    </div>

    <!-- Menu Items List -->
    <div v-if="menuitems && menuitems.length">
      <MenuItem
        v-for="menu in menuitems"
        :key="menu.code"
        :id="menu.id"
        :code="menu.code"
        :name="menu.name"
        :imgurl="menu.imageUrl"
        :catid="menu.screenMenuCategory.id"
        :baseurl="baseurl"
        :price="menu.price"
        :sortorder="menu.sortOrder"
        :servicetag="menu.serviceTag"
        :submenutag="menu.subMenuTag"
        :description="menu.description"
        
        @deleted="deleteMenuItem"
      />
    </div>

    <!-- No Items Message -->
    <div class="mt-28" v-else>
      <h1 class="text-center text-gray-400">آیتمی ذخیره نشده است.</h1>
    </div>

    <!-- Pagination Controls (Sticky) -->
    <div class="flex justify-center items-center gap-4 mt-4 sticky bottom-0 bg-gray-800 z-10 py-4" v-if="pagination.totalPages > 0">
      <button 
        @click="prevPage" 
        :disabled="!pagination.hasPrevious" 
        :class="{'bg-green-500 text-white': pagination.hasPrevious, 'bg-gray-300': !pagination.hasPrevious}" 
        class="px-4 py-2 rounded-lg disabled:opacity-50">
        قبلی
      </button>
      <span class="text-white">صفحه {{ pagination.pageNumber }} از {{ pagination.totalPages }}</span>
      <button 
        @click="nextPage" 
        :disabled="!pagination.hasNext" 
        :class="{'bg-green-500 text-white': pagination.hasNext, 'bg-gray-300': !pagination.hasNext}" 
        class="px-4 py-2 rounded-lg disabled:opacity-50">
        بعدی
      </button>
    </div>

    <!-- Delete Modal -->
    <TransitionRoot appear :show="deleteModal" as="template">
      <Dialog as="div" @close="closeDeleteModal">
        <div class="fixed inset-0 z-10 overflow-y-auto">
          <div class="min-h-screen px-4 text-center">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-50"/>
            </TransitionChild>
  
            <span class="inline-block h-screen align-middle" aria-hidden="true">
              &#8203;
            </span>
  
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0 scale-95"
                enter-to="opacity-100 scale-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100 scale-100"
                leave-to="opacity-0 scale-95">
              <div
                  class="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                <DialogTitle
                    as="h3"
                    class="text-lg font-medium leading-6 text-gray-900 text-right">
                  حذف منو
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-sm text-gray-500 text-right">
                    آیا از حذف گروه مطمئن هستید ؟
                  </p>
                </div>
  
                <div class="mt-4">
                  <button
                      type="button"
                      class="bg-gray-300 rounded-lg px-4 p-2 text-sm"
                      @click="closeDeleteModal">
                    لغو
                  </button>
                  <button
                      type="button"
                      class="bg-red-500 rounded-lg px-4 p-2 text-sm text-white mr-4"
                      @click="confirmDelete">
                    حذف
                  </button>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>


<script>
import Button from '@/components/Button.vue';
import MenuItem from "@/components/MenuItemCard";
import { getCategoryItems, DeleteMenuItem } from "@/API/API.js";
import store from '../store';
import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    DialogTitle,
  } from "@headlessui/vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: "MenuList",
  components: { MenuItem, Button, Dialog, DialogOverlay, DialogTitle, TransitionRoot, TransitionChild},
  data() {
    return {
      menuitems: [],
      deleteModal: false,
      baseurl:process.env.VUE_APP_BASE_URL,
      deleteId: '',
      menuitempath: '/cat/' + this.$route.params.id + '/add',
      pageNumber: 1,
      pageSize: 2,
      pagination: {}, // ذخیره اطلاعات صفحه‌بندی
      searchTerm: ""
    };
  },
  async created() {
    this.$Progress.start();
    await this.getMenuItemList();
    this.$Progress.finish();
  },
  methods: {
    async getMenuItemList() {
      try {
        const response = await getCategoryItems(
          this.$route.params.id,
          this.pageNumber,
          this.pageSize,
          true,  // برای محاسبه تعداد کل آیتم‌ها
          this.searchTerm
        );
        console.log(999);
        console.log(response.data);
        this.menuitems = response.data.items;
        this.pagination = response.data.pagination;
        console.log(this.pagination);
      } catch (error) {
        console.error("Failed to load Items:", error);
        this.menuitems= [];
        toast.error("خطا در بارگذاری کالاها");
      }
    },
    async searchItems() {
      this.pageNumber = 1; // بازنشانی صفحه به اول
      await this.getMenuItemList();
    },
    async prevPage() {
      if (this.pagination.hasPrevious) {
        this.pageNumber--;
        await this.getMenuItemList();
      }
    },
    async nextPage() {
      if (this.pagination.hasNext) {
        this.pageNumber++;
        await this.getMenuItemList();
      }
    },
    async deleteMenuItem(id) {
      console.log(123456);
      this.deleteModal = true;
      this.deleteId = id;
    },
    confirmDelete() {
      console.log(1234567);
      DeleteMenuItem(store.getters.slug, this.deleteId).then(async () => {
        await this.getMenuItemList();
        this.deleteModal = false;
      });
    },
    closeDeleteModal() {
      this.deleteModal = false;
    }
  }
};
</script>
